import { render } from "./classroom-detail.vue?vue&type=template&id=0f8a070f"
import script from "./classroom-detail.vue?vue&type=script&lang=ts"
export * from "./classroom-detail.vue?vue&type=script&lang=ts"
script.render = render

export default script